export const initialState = {
  isFetched: false,
  isExpired: false,
  id: null,
  name: null,
  price: null,
  discount: null,
  media: [],
  timeLeft: null,
  startDate: null,
  products: [],
}


export const set = (state, payload /* item */) => ({
  ...initialState,
  ...payload,
  isFetched: true,
})

export const setExpired = (state, payload) => ({
  ...state,
  isExpired: payload,
})

export const setIsFetched = (state, payload /* isFetched */) => ({
  ...state,
  isFetched: payload,
})
